exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "dt[data-v-4b5275e4], dd[data-v-4b5275e4] {\n  margin-bottom: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\ndt[data-v-4b5275e4] {\n  min-width: 100px;\n  width: 30%;\n}\ndd[data-v-4b5275e4] {\n  width: 60%;\n}\n", ""]);
